import React, { useState, Dispatch, SetStateAction } from 'react';
import { Grid } from '@material-ui/core';
import { Table } from 'antd';

interface TableTypes {
  data: [] | any;
  columns?:
    | {
        title: string;
        dataIndex: string;
        key: string;
        render: () => void;
      }[]
    | any;
  setVisible: (a: boolean) => void;
  setCurrentRow: Dispatch<SetStateAction<never[]>>;
  paginationSize: any;
  paginationData: number;
}

const TableComponent = ({
  data = [],
  columns = [],
  setVisible,
  setCurrentRow,
  paginationSize,
  paginationData,
}: TableTypes) => {
  const [total] = useState(data.length);

  return (
    <Grid
      item
      xs={12}
      className="p-0"
    >
      <Table
        columns={columns}
        dataSource={data}
        onRow={(record) => {
          return {
            onClick: (event) => {
              setCurrentRow(record);
              setVisible(true);
            },
          };
        }}
        pagination={{
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          showTotal: (total, range) =>
            `Total ${total} items, current ${range[0]}-${range[1]}`,
          defaultPageSize: paginationData,
          defaultCurrent: 1,
          size: 'small',
          total,
          onChange: (page, pageSize) => {},
          onShowSizeChange: (current, size: number) =>
            paginationSize('pagination', {
              accesibility_and_security_table: size,
            }),
        }}
      />
    </Grid>
  );
};

export default TableComponent;
